import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddPracticeInfoProviders,
  fetchPracticeInfoProviders,
  fetchReasonCodeActive,
  fetchSearchedProviders,
  fetchUpdateStatus,
} from "../../../store/PracticeInfo/ProviderDetailsActions";
import ToggleButton from "../../../common/ToggleButton";
import { Link, useLocation } from "react-router-dom";
import "./providersDetails.scss";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import CgInputField from "../../../common/CgInputField";
import CgDropdown from "../../../common/CgDropdown";
import defaultProfileIcon from "../../../assets/images/defaultProfileIcon.svg";
import { clearSearchProvidersData } from "../../../store/PracticeInfo/ProvidersDetailsReducers";

const providersLicenseStateDropdownOptions = [
  { id: 0, value: "AK" },
  { id: 1, value: "AL" },
  { id: 2, value: "AR" },
  { id: 3, value: "AZ" },
  { id: 4, value: "CA" },
  { id: 5, value: "CO" },
  { id: 6, value: "CT" },
  { id: 7, value: "PA" },
  { id: 8, value: "DC" },
  { id: 9, value: "DE" },
  { id: 10, value: "FL" },
  { id: 11, value: "GA" },
  { id: 12, value: "GU" },
  { id: 13, value: "HI" },
  { id: 14, value: "IA" },
  { id: 15, value: "ID" },
  { id: 16, value: "IN" },
  { id: 17, value: "IL" },
  { id: 18, value: "KS" },
  { id: 19, value: "LA" },
  { id: 20, value: "MA" },
  { id: 21, value: "MD" },
  { id: 22, value: "ME" },
  { id: 23, value: "MI" },
  { id: 24, value: "MN" },
  { id: 25, value: "MO" },
  { id: 26, value: "MS" },
  { id: 27, value: "MT" },
  { id: 28, value: "NC" },
  { id: 29, value: "ND" },
  { id: 30, value: "NE" },
  { id: 31, value: "NH" },
  { id: 32, value: "NJ" },
  { id: 33, value: "NM" },
  { id: 34, value: "NV" },
  { id: 35, value: "NY" },
  { id: 36, value: "OH" },
  { id: 37, value: "OK" },
  { id: 38, value: "OR" },
  { id: 39, value: "PA" },
  { id: 40, value: "PR" },
  { id: 41, value: "RI" },
  { id: 42, value: "SC" },
  { id: 43, value: "SD" },
  { id: 44, value: "TN" },
  { id: 45, value: "TX" },
  { id: 46, value: "UT" },
  { id: 47, value: "VA" },
  { id: 48, value: "VT" },
  { id: 49, value: "WA" },
  { id: 50, value: "WI" },
  { id: 51, value: "WV" },
  { id: 52, value: "WY" },
];

const onStatusDropDown = [
  {
    name: "Network Status Dispute",
    value: "Network Status Dispute",
  },
  {
    name: "Not Accepting New Patients",
    value: "Not Accepting New Patients",
  },
  {
    name: "Not at Location / Not Practicing",
    value: "Not at Location / Not Practicing",
  },
  {
    name: "I do not recognize this provider",
    value: "I do not recognize this provider",
  },
  {
    name: "Retired/Deceased",
    value: "Retired/Deceased",
  },
];

const ProvidersDetails = ({
  onlyPopup = false,
  openProvidersDetailsPopup,
  closePopupCallback = () => {},
}) => {
  const [filterData, setFilterData] = useState("ON");
  const [filteredProvidersList, setFilteredProvidersList] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeTab, setActiveTab] = useState("npi");
  const [searchValue, setSearchValue] = useState();
  const [searchResult, setSearchResult] = useState([]);
  const [statusDropdown, setStatusDropdown] = useState("");
  const [editItem, setEditItem] = useState({});
  const [selectedProvider, setSelectedProvider] = useState("");
  const [error, setError] = useState("");
  const [resetValues, setResetValues] = useState(false);
  const [showError, setShowError] = useState(false);
  const [offStatusDropdownOption, setOffStatusDropdownOption] = useState([]);

  const { practiceInfoProvidersDetails, providersDetailsErrorMsg } =
    useSelector((state) => state.practiceInfoProvidersDetails);
  const { searchProvidersData, searchProvidersErrorMsg } = useSelector(
    (state) => state.searchProvidersData
  );
  const { addPracticeInfoProvidersErrorMsg } = useSelector(
    (state) => state.addPracticeInfoProviders
  );
  const { reasonCodeActive, reasonCodeErrorMsg } = useSelector(
    (state) => state.reasonCodeActive
  );
  const { statusErrorMsg } = useSelector((state) => state.providersStatus);

  const dispatch = useDispatch();

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  useEffect(() => {
    if (practiceId) {
      dispatch(fetchPracticeInfoProviders(practiceId));
    }
  }, [practiceId]);

  useEffect(() => {
    if (reasonCodeActive) {
      const offStatusDropdown = reasonCodeActive?.map((item) => {
        return {
          name: item?.reasonCode,
          value: item?.reasonCode,
        };
      });
      setOffStatusDropdownOption(offStatusDropdown);
    }
  }, [reasonCodeActive]);

  useEffect(() => {
    if (editItem?.providerDisplayId?.length > 0) {
      dispatch(fetchReasonCodeActive());
    }
  }, [editItem]);

  useEffect(() => {
    if (
      providersDetailsErrorMsg ||
      searchProvidersErrorMsg ||
      reasonCodeErrorMsg ||
      addPracticeInfoProvidersErrorMsg ||
      statusErrorMsg
    ) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [
    providersDetailsErrorMsg,
    searchProvidersErrorMsg,
    reasonCodeErrorMsg,
    addPracticeInfoProvidersErrorMsg,
    statusErrorMsg,
  ]);

  useEffect(() => {
    if (openProvidersDetailsPopup) {
      setOpenPopup(openProvidersDetailsPopup);
    }
  }, [openProvidersDetailsPopup]);

  useEffect(() => {
    const activeProviders =
      practiceInfoProvidersDetails?.items?.length > 0
        ? practiceInfoProvidersDetails.items.filter(
            (provider) => provider?.status?.providerStatus?.isActive === "true"
          )
          .sort((a, b) => {
          const nameA = a.firstName?.toLowerCase() || "";
          const nameB = b.firstName?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        })
        : [];

    if (filterData === "ALL") {
      setFilteredProvidersList(activeProviders);
    } else if (filterData === "ON") {
      const updatedList = activeProviders.filter(
        (provider) =>
          provider?.status?.accessPointStatus?.isDisplayedOnSite === "true"
      );
      setFilteredProvidersList(updatedList);
    } else if (filterData === "OFF") {
      const updatedList = activeProviders.filter(
        (provider) =>
          provider?.status?.accessPointStatus?.isDisplayedOnSite === "false"
      );
      setFilteredProvidersList(updatedList);
    }
  }, [filterData, practiceInfoProvidersDetails]);

  useEffect(() => {
    if (searchProvidersData?.length > 0) {
      if (searchValue?.licenseState?.length > 0) {
        const filteredLicenseStateData = searchProvidersData.filter((item) =>
          getProvidersByLicensestate(item)
        );
        setSearchResult(filteredLicenseStateData);
        return;
      }
      setSearchResult(searchProvidersData);
    } else if (searchProvidersData?.length === 0) {
      setSearchResult([]);
    }
  }, [searchProvidersData]);

  const getProvidersByLicensestate = (item) => {
    if (item?.licenses?.length > 0) {
      return item.licenses.find(
        (license) => license?.licenseState === searchValue?.licenseState
      );
    }
    return item;
  };

  const handleSearch = () => {
    if (activeTab === "npi") {
      dispatch(
        fetchSearchedProviders({
          searchType: "npi",
          query: searchValue,
          state: "all",
        })
      );
      return;
    }
    if (activeTab === "license") {
      dispatch(
        fetchSearchedProviders({
          searchType: "license-number",
          query: searchValue.license,
          state: searchValue.licenseState,
        })
      );
    }
  };

  const isAddDisabled = () => {
    return (
      !!error ||
      !searchValue ||
      (searchValue && (!searchResult || searchResult.length === 0)) ||
      !selectedProvider
    )
  }

  const handleUpdateProvidersDetails = async (providerData) => {
    providerData.isActive = providerData.isActive === "ON" ? "true" : "false";
    const providerDisplayId = editItem.providerDisplayId;
    await dispatch(
      fetchUpdateStatus({
        providerDisplayId,
        practiceId,
        payload: providerData,
      })
    ).then((response) => {
      if (response?.payload?.status === 200) {
        dispatch(fetchPracticeInfoProviders(practiceId));
      }
    });
  };

  const getAllLicenses = (licenses) => {
    return licenses?.map((licenseItem, index) => (
      <div key={index}>
        {licenseItem?.licenseState} : {licenseItem?.licenseNumber}
      </div>
    ));
  };

  const handleSelectedProvider = (providerDisplayId) => {
    const providerDisplayIdExist = practiceInfoProvidersDetails?.items?.find(
      (item) => item?.providerDisplayId === providerDisplayId
    );
    setSelectedProvider((prev) =>
      prev === providerDisplayId ? "" : providerDisplayId
    );
    if (providerDisplayIdExist) {
      setError("This provider record already exists at this location.");
      return;
    }
    setError("");
  };

  const getSelectedCheckMark = (displayId) => {
    if (error && selectedProvider === displayId) {
      return <div className="checkMarkError">{error}</div>;
    }
    if (selectedProvider === displayId) {
      return (
        <div className="checkIcon">
          <i className="bi bi-check-circle"></i>
        </div>
      );
    }
  };

  const handleCancel = () => {
    setResetValues(!resetValues);
    setActiveTab("npi");
    setSearchValue();
    setSelectedProvider("");
    setSearchResult();
    setError();
    setStatusDropdown("");
    setOpenPopup(!openPopup);
    closePopupCallback();
    dispatch(clearSearchProvidersData());
  };

  const handleAddProvider = async () => {
    if (selectedProvider) {
      await dispatch(
        fetchAddPracticeInfoProviders({
          practiceId,
          displayId: selectedProvider,
        })
      ).then((response) => {
        if (response?.payload?.status === 200) {
          dispatch(fetchPracticeInfoProviders(practiceId));
        }
      });
      handleCancel();
    }
  };

  const handleTabs = (tab) => {
    setActiveTab(tab);
    setSearchValue();
    setSearchResult();
    setSelectedProvider();
  };

  const providersStatusSchema = [
    {
      component: "dropdown",
      name: "isActive",
      dropdownOptions: [
        {
          name: "ON",
          value: "ON",
        },
        {
          name: "OFF",
          value: "OFF",
        },
      ],
      required: true,
      onSelectCallBack: (name, value) => {
        setStatusDropdown(value);
      },
      defaultValue:
        editItem?.status?.accessPointStatus?.isDisplayedOnSite === "false"
          ? "ON"
          : "OFF",
    },
    {
      component: "dropdown",
      name: "reasonCode",
      required: true,
      dropdownOptions:
        statusDropdown === "ON" ? offStatusDropdownOption : onStatusDropDown,
      dropdownPlaceHolder: "Select a Reason",
    },
    {
      component: "textarea",
      name: "note",
      cols: 83,
      rows: 10,
      needBorder: true,
      onChangeCallback: () => {},
    },
  ];

  const RenderPracticeInfoProvidersDetailsError = () => {
    if (!showError) return null;
    return (
      <div
        className="overlay-alert alert alert-danger alertTopPosition"
        role="alert"
      >
        {providersDetailsErrorMsg ||
          searchProvidersErrorMsg ||
          reasonCodeErrorMsg ||
          addPracticeInfoProvidersErrorMsg ||
          statusErrorMsg}
      </div>
    );
  };

  const RenderProvidersList = () => {
    if (!filteredProvidersList) return null;
    return (
      <>
        {filteredProvidersList?.map((providersItem, index) => (
          <div key={index} className="providersCardWrapper">
            <div className="providersCardContent">
              <div>
                {providersItem?.profileImage &&
                providersItem?.profileImage?.large ? (
                  <img
                    className="profileImage"
                    src={providersItem?.profileImage?.small}
                    alt="Providers profile Image"
                  />
                ) : (
                  <img
                    className="profileImage"
                    src={defaultProfileIcon}
                    alt="Missing Providers profile Image"
                  />
                )}
              </div>
              <div className="providersCardHeaderAndBodyWrapper">
                <div className="providersCardHeaderWrapper">
                  <Link
                    className="providersName"
                    to={`/provider/${providersItem?.providerDisplayId}/profile-information/info?fromPractice=${practiceId}`}
                  >
                    Dr. {providersItem?.firstName} {providersItem?.middleName}{" "}
                    {providersItem?.lastName}
                  </Link>
                  <div
                    data-testid={`${
                      providersItem.status?.accessPointStatus
                        ?.isDisplayedOnSite === "true"
                        ? "toggleOn"
                        : "toggleOff"
                    }`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ToggleButton
                      key={statusDropdown}
                      customToggleStyle
                      defaultValue={
                        providersItem?.status?.accessPointStatus
                          ?.isDisplayedOnSite === "true"
                          ? true
                          : false
                      }
                      isReasonRequired={
                        providersItem?.status?.accessPointStatus
                          ?.isDisplayedOnSite === "false"
                          ? true
                          : false
                      }
                      fromProvidersList={true}
                      statusUpdate={providersItem?.status}
                      onChangeCallback={() => {
                        const status =
                          providersItem?.status?.accessPointStatus
                            ?.isDisplayedOnSite === "true"
                            ? "OFF"
                            : "ON";
                        setStatusDropdown(status);
                        setEditItem(providersItem);
                        setOpenPopup(!openPopup);
                        closePopupCallback();
                      }}
                    />
                  </div>
                </div>
                <div className="providersCardBodyWrapper">
                  <div className="providersCardBodyItem">
                    NPI - {" "}
                    <span className="boldLtr">
                      {providersItem.nationalProviderIdentifier}
                    </span>
                  </div>
                  <div className="providersCardBodyItem">
                    Licenses - {" "}
                    <span className="boldLtr">
                      {
                        providersItem.licenses.providerLicenseItemResponseDTOs
                          .stateCode
                      }
                      :{" "}
                      {
                        providersItem.licenses.providerLicenseItemResponseDTOs
                          .number
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  const RenderProvidersStatus = () => {
    return (
      <div>
        <div className="popupHeader"> YOUR STATUS </div>
        <div className="providersPopupDescWrapper">
          <div className="providersPopupDesc">
            {`These changes will be reflected in Brighter's records.`}
          </div>
          <div className="providersPopupDesc">
            Please notify contracted carriers of any changes to providers at
            your practice.
          </div>
        </div>
        <div className="statusWrapper">
          <CgFormCreator
            key={editItem}
            schema={providersStatusSchema}
            onSubmitCallback={(res) => {
              handleUpdateProvidersDetails(res);
              setStatusDropdown("");
              setOpenPopup(!openPopup);
              closePopupCallback();
            }}
            onCancel={() => {
              setEditItem({});
              setStatusDropdown("");
              setOpenPopup(!openPopup);
              closePopupCallback();
            }}
          />
        </div>
      </div>
    );
  };

  const RenderAddProvidersForm = () => {
    return (
      <div>
        <div className="popupHeader">ADD PARTICIPATING PROVIDER</div>
        <div className="providersPopupDescWrapper">
          <div className="providersPopupDesc">
            {`These Changes will be reflected in Brighter's records.`}
          </div>
          <div className="providersPopupDesc">
            {`Please notify contracted carriers of any changes to providers at your practice.`}
          </div>
        </div>

        <div className="providersTabs">
          <div
            className={activeTab === "license" ? "active" : "inactive"}
            onClick={() => handleTabs("license")}
          >
            Search by License
          </div>
          <div
            className={activeTab === "npi" ? "active" : "inactive"}
            onClick={() => handleTabs("npi")}
          >
            Search by NPI
          </div>
        </div>

        {activeTab === "npi" && (
          <div className="providersFormWrapper">
            <div>
              <CgInputField
                type="text"
                name="npi"
                label=""
                placeholder="NPI"
                valueChangeCallback={(name, value) => setSearchValue(value)}
                resetValue={resetValues}
              />
            </div>
            <div>
              <CgInputField
                btnClassName="btn edit-button searchButton"
                type="button"
                name="search"
                label="Search"
                handleButtonClickCallback={() => handleSearch()}
              />
            </div>
          </div>
        )}

        {activeTab === "license" && (
          <div className="providersFormWrapper">
            <div>
              <CgInputField
                type="text"
                name="license"
                label=""
                placeholder="license number"
                valueChangeCallback={(name, value) =>
                  setSearchValue((prev) => ({ ...prev, [name]: value }))
                }
              />
            </div>
            <div>
              <CgDropdown
                dropdownOptions={providersLicenseStateDropdownOptions}
                onSelectCallBack={(name, value) =>
                  setSearchValue((prev) => ({ ...prev, [name]: value }))
                }
                name="licenseState"
                dropdownPlaceHolder="license state"
                dropdownClassName="dropdown"
              />
            </div>
            <div>
              <CgInputField
                btnClassName="btn edit-button searchButton"
                type="button"
                name="search"
                label="Search"
                handleButtonClickCallback={() => handleSearch()}
              />
            </div>
          </div>
        )}

        {searchResult?.length > 0 ? (
          <div className="searchResultWrapper">
            <p>
              We found {searchResult?.length}{" "}
              {searchResult?.length > 1 ? "providers" : "provider"} for{" "}
              {searchValue?.license
                ? `license number : ${searchValue?.license} ${
                    searchValue?.licenseState
                      ? `in ${searchValue?.licenseState}`
                      : ""
                  }`
                : `NPI : "${searchValue}"`}
            </p>
            <h6>Select the correct provider:</h6>
            {searchResult?.map((providersItem, index) => (
              <div
                className="providerCardWrapper"
                key={index}
                onClick={() => handleSelectedProvider(providersItem?.displayId)}
              >
                <div>
                  {providersItem?.image[0]?.large?.length > 0 ? (
                    <img
                      className="profileImage"
                      src={providersItem?.image[0]?.large}
                      alt="Providers profile Image"
                    />
                  ) : (
                    <img
                      className="profileImage"
                      src={defaultProfileIcon}
                      alt="Missing Providers profile Image"
                    />
                  )}
                </div>
                <div className="providersNameDiv">
                  <p>
                    {providersItem?.firstName || ""}{" "}
                    {providersItem?.middleName || ""}{" "}
                    {providersItem?.lastName || ""}
                  </p>
                </div>
                <div className="borderLeft">
                  <p>NPI</p>
                  <p>{providersItem?.nationalProviderIdentifier}</p>
                </div>
                <div className="borderLeft">
                  <p>LICENSE</p>
                  {getAllLicenses(providersItem?.licenses)}
                </div>
                <div className="borderLeft">
                  <p>STATE</p>
                  <p>{providersItem?.state}</p>
                </div>
                {getSelectedCheckMark(providersItem?.displayId)}
              </div>
            ))}
          </div>
        ) : (
          searchValue &&
          searchResult && (
            <p>
              We cannot find a provider. Please contact provider relations at
              424-316-2534
            </p>
          )
        )}
        <div className="providersButtonWrapper">
          <button
            className="saveBtn"
            onClick={handleAddProvider}
            disabled={isAddDisabled()}
          >
            Add
          </button>
          <button className="cancelBtn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    );
  };

  const RenderProvidersPopup = () => {
    return (
      <div>
        <PopupModal
          isOpen={openPopup}
          onClose={() => handleCancel()}
          customRender={
            statusDropdown ? RenderProvidersStatus : RenderAddProvidersForm
          }
          width={statusDropdown ? "50%" : "80%"}
        />
      </div>
    );
  };

  return (
    <div className="providersDetailsWrapper">
      {!onlyPopup && (
        <div>
          <h2 className="info-section-header text-uppercase">Your Providers</h2>
          <div className="providersListWrapper">
            <div className="providersHeader">
              <div className="providersFilterText">
                Click on a provider below to see more details
              </div>
              <div className="providersFilters">
                <div
                  className={`${
                    filterData === "ALL" ? "filterBtn" : "noFilterBtn"
                  }`}
                  onClick={() => setFilterData("ALL")}
                >
                  ALL
                </div>
                |
                <div
                  className={`${
                    filterData === "ON" ? "filterBtn" : "noFilterBtn"
                  }`}
                  onClick={() => setFilterData("ON")}
                  data-testid="filterBtnOn"
                >
                  ON ONLY
                </div>
                |
                <div
                  className={`${
                    filterData === "OFF" ? "filterBtn" : "noFilterBtn"
                  }`}
                  onClick={() => setFilterData("OFF")}
                  data-testid="filterBtnOff"
                >
                  OFF ONLY
                </div>
              </div>
            </div>
            {filteredProvidersList?.length > 0 ? (
              RenderProvidersList()
            ) : (
              <div className="noProvidersDiv">
                No providers mapped to this practice
              </div>
            )}

            <button
              className="btn edit-button addProvidersButton"
              onClick={() => {
                setResetValues(!resetValues);
                setOpenPopup(true);
              }}
            >
              {"+ADD PROVIDER"}
            </button>
          </div>
        </div>
      )}
      {RenderPracticeInfoProvidersDetailsError()}
      {RenderProvidersPopup()}
    </div>
  );
};
export default ProvidersDetails;
